import type { Testimonial } from '../types/content';
export const stats = [['4', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'Listo para usar']];
export const testimonials: Testimonial[] = [{
  name: 'Valeria M.',
  place: 'Buenos Aires',
  quote: "Terminaba una conversación y podía seguir repasándola durante horas. El protocolo me ayuda a cortar antes y seguir con mi día."
}, {
  name: 'Luciana C.',
  place: 'Córdoba',
  quote: 'Lo que más me gustó es que no tengo que sentarme a descubrir qué hacer. Busco lo que me está pasando, sigo los pasos y listo.'
}, {
  name: 'Andrea R.',
  place: 'Rosario',
  quote: 'Me ayudó mucho con esas situaciones que ya terminaron pero seguían ocupándome la cabeza. Ahora tengo una forma más clara de darles un cierre.'
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Camila F.',
  place: 'Mendoza',
  quote: 'Antes esperaba un mensaje y empezaba a imaginar mil explicaciones. Ahora tengo respuestas concretas para no convertir cada silencio en una historia.'
}, {
  name: 'Natalia G.',
  place: 'La Plata',
  quote: 'Me servía poco leer teoría cuando estaba saturada. Acá puedo encontrar la situación, seguir una secuencia y saber cuál es el próximo paso.'
}, {
  name: 'Paula M.',
  place: 'Neuquén',
  quote: 'Siempre me costó poner límites porque después me sentía culpable. Tener ejemplos cálidos, directos y firmes me simplifica muchísimo esas conversaciones.'
}, {
  name: 'Daniela S.',
  place: 'Mar del Plata',
  quote: 'El plan de 21 días fue clave porque hay bastante material. No tengo que decidir qué usar primero: ya viene organizado.'
}];